import IncomeStatement from "./IncomeStatement";

export default IncomeStatement;
